<button
	mat-button
	class="sidebar-menu-trigger"
	[matMenuTriggerFor]="profileMenu"
	[attr.aria-label]="'sidebar.setting' | transloco"
	[attr.aria-haspopup]="'menu'"
	[attr.aria-expanded]="profileMenuTrigger.menuOpen"
	[attr.aria-controls]="profileMenu.panelId"
	#profileMenuTrigger="matMenuTrigger"
>
	<mat-icon fontIcon="manage_accounts" aria-hidden="true"></mat-icon>
	{{ 'sidebar.setting' | transloco }}
</button>
<mat-menu #profileMenu="matMenu" yPosition="above" (menuOpened)="onLoadRepresentations()">
	<div class="menu-content">
		<button mat-menu-item [routerLink]="['/user-settings']" [attr.aria-label]="'sidebar.profile' | transloco">
			<mat-icon fontIcon="account_circle" aria-hidden="true"></mat-icon>
			{{ 'sidebar.profile' | transloco }}
		</button>
		@if (canReceiveRepresentation()) {
			<button
				mat-menu-item
				type="button"
				[matMenuTriggerFor]="representationMenu"
				(click)="onLoadRepresentations()"
				(mouseenter)="onLoadRepresentations()"
				(focus)="onLoadRepresentations()"
				[attr.aria-label]="'sidebar.representativeMode' | transloco"
			>
				<mat-icon fontIcon="groups" aria-hidden="true"></mat-icon>
				{{ 'sidebar.representativeMode' | transloco }}
			</button>
		}
		<button mat-menu-item type="button" (click)="onLogout()" [attr.aria-label]="'sidebar.logout' | transloco">
			<mat-icon fontIcon="logout" aria-hidden="true"></mat-icon>
			{{ 'sidebar.logout' | transloco }}
		</button>
	</div>
</mat-menu>
<mat-menu #representationMenu="matMenu" yPosition="above" (menuOpened)="onLoadRepresentations()">
	<div class="menu-content">
		@if (representationsLoading()) {
			<button mat-menu-item disabled>Loading...</button>
		} @else if (representations().length === 0) {
			<button mat-menu-item disabled>No representatives found</button>
		} @else {
			@for (user of representations(); track user.id) {
				<button mat-menu-item type="button" (click)="onSelectRepresentative(user)">
					{{ getUserLabel(user) }}
				</button>
			}
		}
	</div>
</mat-menu>
